import HotelDatePicker from './DatePicker/HotelDatePicker.vue'
import css from './assets/scss/index.scss'

export default HotelDatePicker
export { css }
